import React from 'react'
import PropTypes from 'prop-types'

import { config } from 'aws-cognito-redux-saga'

class Auth extends React.Component {
  static propTypes = {
    getUser: PropTypes.func
  }

  componentWillMount() {
    config.config.set({
      region: 'us-west-2',
      IdentityPoolId: '',
      UserPoolId: 'us-west-2_LxV4t6X6C',
      ClientId: '33j373kc4vukol7p4dc7kcregj'
    })

    this.props.getUser()
  }

  render() {
    return null
  }
}

export default Auth



// WEBPACK FOOTER //
// ./src/components/Auth/Auth.js